import { Component, ChangeDetectionStrategy } from '@angular/core';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';

@Component({
  standalone: false,
  selector: 'odin-unauthorised',
  templateUrl: './unauthorised.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./unauthorised.component.scss'],
})
export class UnauthorisedComponent {

  public errorIcon: IconDefinition = faTriangleExclamation;
}
